export default __webpack_public_path__ + "static/media/desktops.24e20fa3.jpg";